// @flow
import React, { type Node } from 'react';

import PlainTooltip from 'app/common/ui-next/plain-tooltip';

import styles from './SubjectTitle.scss';


type Props = {
  title: string,
  children: Node,
}

const SubjectTitle = ({ title, children }: Props): Node => {
  return (
    <div className={styles.root}>
      <PlainTooltip
        text={title}
        className={styles.title}
        hideWithoutOverflow
      >
        {title}
      </PlainTooltip>

      {children}
    </div>
  );
};

export default SubjectTitle;
